import { instance, next } from "./base";

export const getLatestOrders = async () => {
  const { data } = await instance()
    .get("/api/v1/admin/top-orders")
    .catch((e) => next(e));
  return data?.data;
};

export const getOrderDetail = async (id) => {
  const { data } = await instance()
    .get(`/api/v1/admin/orders/${id}`)
    .catch((e) => next(e));
  return data?.data;
};

export const getDashboardOrders = async () => {
  const { data } = await instance()
    .get("/api/v1/admin/dashboard/latest-orders")
    .catch((e) => next(e));
  return data?.data;
};

export const fetchOrders = async () => {
  const { data } = await instance()
    .get("/api/v1/admin/orders")
    .catch((e) => next(e));
  return data?.data;
};

export const getOrderSummary = async () => {
  const { data } = await instance()
    .get("/api/v1/admin/orders/summary")
    .catch((e) => next(e));
  return data?.data;
};

export const getOrderTopCategories = async () => {
  const { data } = await instance()
    .get("/api/v1/admin/orders/top-categories")
    .catch((e) => next(e));
  return data?.data;
};

export const getOrderChart = async () => {
  const { data } = await instance()
    .get("/api/v1/admin/orders/chart")
    .catch((e) => next(e));
  return data?.data;
};

export const getUserOrders = async (id) => {
  const { data } = await instance()
    .get(`/api/v1/admin/users/${id}/orders`)
    .catch((e) => next(e));
  return data?.data;
};

export const getUserTransactions = async (id, page) => {
  const { data } = await instance()
    .get(`/api/v1/admin/users/${id}/transactions`, { params: { page} })
    .catch((e) => next(e));
  return data?.data;
};